import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Avatar from '@mui/material/Avatar';
import CONSTANTS from '../../utils/constants/UIConstants';

interface TextFieldExpandedProps {
	value: string;
	label: string;
	disabled?: boolean;
	showAvatar?: boolean;
	avatarSrc?: string;
	addStyle?: string;
	alarmType?: number;
	isEditingOutput?: boolean;
	onChange?: (e: any) => void;
	textFieldStyle?: string;
}

const TextFieldExpanded: React.FC<TextFieldExpandedProps> = ({
	value,
	label,
	disabled = false,
	showAvatar = false,
	avatarSrc,
	addStyle,
	alarmType,
	isEditingOutput = false,
	onChange,
	textFieldStyle,
}) => {
	const getColorInfo = (alarm: number) => {
		switch (alarm) {
			case 1:
				return { color: '#CE0E0E', type: 'red' };
			case 2:
				return { color: '#FFA726', type: 'yellow' };
			case 3:
				return { color: '#66BB6A', type: 'green' };
			default:
				return { color: '#556670', type: 'default' };
		}
	};

	const borderColor = getColorInfo(alarmType || 10).color;
	const [textFieldValue, setTextFieldValue] = useState(value);

	useEffect(() => {
		setTextFieldValue(value);
	}, [value]);

	const getInitials = (name: string) => {
		const parts = name.split(' ');
		if (parts.length > 1) {
			return parts[0][0] + parts[parts.length - 1][0];
		}
		return name[0];
	};

	const initials = getInitials(textFieldValue);

	return (
		<div className="flex">
			<TextField
				sx={{
					'& .MuiInputLabel-root': {
                        maxWidth: label.length >= 10 ? '130%' : '100%',
                        backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
                        padding: '0.25rem 0.35rem 0 0.35rem',
                        marginLeft: '-0.35rem',
                        marginTop: '-0.10rem',
                        borderRadius: '5px',
                    },
					'& .MuiInputBase-input.Mui-disabled': {
						WebkitTextFillColor: '#2C2C2C',
					},
					'.MuiInputBase-root': {
						height: 48,
						textAlign: 'right',
					},
					'.Mui-disabled': {
						color: '#556670',
					},
					'.MuiFormLabel-root.Mui-disabled': {
						color: '#556670',
						
					},
					'.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
						borderColor: borderColor,
            			borderRadius: '2px',
					},
					'&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
						{
							borderColor: borderColor, 
              				borderRadius: '2px',
						},
					'.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
						{
							borderColor: borderColor,
              				borderRadius: '2px',
						},
					...(disabled && !isEditingOutput
						? {
								'.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
									{
										border: 'none',
									},
								'&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
									{
										border: 'none',
									},
								'.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
									{
										border: 'none',
									},
						  }
						: {}),
				}}
				value={textFieldValue}
				onChange={(e) => {
					setTextFieldValue(e.target.value);
					if (onChange) {
						onChange(e);
					}
				}}
				label={label}
				className={`!mb-4 ${textFieldStyle ?? ""}`}
				disabled={disabled}
				InputProps={
					showAvatar
						? {
								classes: {
									input: addStyle,
								},
								startAdornment: (
									<InputAdornment position="start">
										<Avatar
											style={{
												backgroundColor: '#BEE0A0',
												color: '#2C2C2C',
												fontSize: '0.75rem',
											}}
                      className="!w-7 !h-7"
										>
											{initials}
										</Avatar>
									</InputAdornment>
								),
						  }
						: undefined
				}
			/>
		</div>
	);
};

export default TextFieldExpanded;
